export enum ERPSystemEnum {
 None,
 MoneyS3,

}